import type { OilAndGasFieldArea } from "./types"

export { OilAndGasFieldType } from "./types"
export type { OilAndGasFieldArea } from "./types"

let fldAreaPromise: Promise<OilAndGasFieldArea[]> | undefined

// created by AI: cache the public JSON request so the large geometry payload stays out of the JS bundle.
export function getFldArea(): Promise<OilAndGasFieldArea[]> {
	fldAreaPromise ??= fetch("/oilAndGasData/fldArea.json").then(async (response) => {
		if (response.ok === false) {
			throw new Error(`Failed to load oil and gas field areas: ${response.status}`)
		}

		return (await response.json()) as OilAndGasFieldArea[]
	})

	return fldAreaPromise
}
